import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            gap: {base: 'xxsmall.md', md: 'xsmall.md'},
            alignItems: 'center',
            marginTop: remCalc(36),
            marginBottom: {md: remCalc(17)},
        },
        title: {
            color: 'text.primary',
            textStyle: 'head-small',
            fontWeight: 'medium',
        },
        quantity: {
            textStyle: 'head-small',
            fontWeight: 'bold',
            color: 'text.secondary',
        },
        editorialComponentsContainer: {},
        searchTitle: {
            textStyle: 'body-xxlarge',
            color: 'text.default',
            fontWeight: 'normal',
            gap: 'xxsmall.base',
        },
        searchSubtitle: {
            textStyle: 'body-medium',
            color: 'text.secondary',
            fontWeight: 'normal',
            gap: 'xxsmall.base',
        },
        searchContainer: {
            gap: {base: 'medium.base', lg: 'medium.lg'},
            paddingTop: {base: 'medium.base', lg: 'medium.lg'},
            marginBottom: {base: 'xsmall.md', lg: 'medium.base'},
        },
        searchContainerTitles: {gap: 'xxsmall.md'},
        searchContainerButtons: {
            gap: 'small.md',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            justifyContent: {base: 'space-between', lg: 'flex-start'},
            whiteSpace: 'nowrap',
            overflowX: 'auto',
        },
        searchSectionButton: {
            //?Removing this margin will add a -2 margin to the button and pretty much remove the border on select
            marginBottom: 0,
            paddingBottom: 'xxsmall.base',
            paddingX: remCalc(0),
            textStyle: 'body-small',
            fontWeight: 'bold',
            _focus: {
                borderBottom: 'large',
                borderStyle: 'solid',
                borderColor: 'border.dark',
                color: 'text.default',
                backgroundColor: 'background.default',
            },
            _selected: {
                borderBottom: 'large',
                borderStyle: 'solid',
                borderColor: 'border.dark',
                color: 'text.default',
                backgroundColor: 'background.default',
            },
            _active: {backgroundColor: 'background.default'},
        },
    },
}
